<template>
  <main id="app" class="text-black dark:bg-gray-800 dark:text-white">
    <nav
      class="flex gap-x-4 mb-4 border-b p-4 bg-gray-50 dark:bg-gray-900 dark:text-blue-300"
    >
      <button
        @click="setPage('ev')"
        :class="activePage == 'ev' ? 'p-2 font-bold underline' : 'p-2 '"
      >
        EV Tacker
      </button>
      <button
        @click="setPage('champs')"
        :class="activePage == 'champs' ? 'p-2 font-bold underline' : 'p-2 '"
      >
        Champions Lookup
      </button>
    </nav>
    <article v-if="activePage == 'ev'">
      <evTracker></evTracker>
    </article>
    <article v-if="activePage == 'champs'">
      <ChampsSpeeds></ChampsSpeeds>
    </article>
    <FooterDisclaimer></FooterDisclaimer>
  </main>
</template>

<script>
import evTracker from "./components/ev-tracker.vue";
import ChampsSpeeds from "./components/champs-speeds.vue";
import FooterDisclaimer from "./components/footer-disclaimer.vue";

export default {
  name: "App",
  components: {
    evTracker,
    ChampsSpeeds,
    FooterDisclaimer,
  },
  data() {
    return {
      activePage: "champs",
    };
  },
  mounted() {},
  methods: {
    setPage(toPage) {
      this.activePage = toPage;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
